import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { ApiInterfaceService } from './api-interface.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileBuildingService {
  constructor(private api: ApiInterfaceService) {}

  /**
   * Sends a request for update latest profile building details.
   *
   * @param profileBuildingObject - Send the latest data to api.
   */
  async updateProfileBuildingDetails(profileBuildingObject): Promise<any> {
    try {
      const res = await this.api.gqlMutation(
        gql`
          mutation ($profileUpdateObject: WorkerUpdateInput!) {
            workerUpdate(input: $profileUpdateObject) {
              user {
                id
              }
            }
          }
        `,
        {
          profileUpdateObject: profileBuildingObject,
        },
      );
      return res;
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
